import { WebsiteHeaderPhotoSchema_PhotoTrio_v1_1_1 } from '@apps/guest/websiteHeader';

export const PHOTO_TRIO_v1_1_1: WebsiteHeaderPhotoSchema_PhotoTrio_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrio-v1_1_1.json',
  presentationLayout: 'photoTrio',
  photos: [],
};
